
import { defineComponent } from "vue-demi";

export default defineComponent({
  name: "VEmployerServicesExtensionBrowse",

  components: {
    Banner: () => import("./components/Banner.vue"),
    Table: () => import("./components/Table.vue"),
  },

  setup() {
    return {};
  },
});
